import {
  Component,
  Input,
  HostBinding,
  ChangeDetectionStrategy,
  ViewChildren,
  QueryList,
  AfterContentChecked,
  ContentChildren,
} from '@angular/core';
import { MenuItem } from '@app/core/models';
import { NavItemLinkDirective } from './nav-item-link.directive';
/**
 * NavItemComponent
 */
@Component({
  selector: 'ecp-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavItemComponent implements AfterContentChecked {
  @HostBinding('class.nav__item') nav__item = true;
  /**
   * label
   */
  @Input() label: string;
  /**
   * title
   */
  @Input() title: string;
  /**
   * icon
   */
  @Input() icon: string[];
  /**
   * link
   */
  @Input() link: string;
  /**
   * fragment
   */
  @Input() fragment: string;
  /**
   * ext
   */
  @Input() ext: boolean;
  /**
   * children
   * @type {any[]}
   */
  @Input() children: MenuItem[] = [];
  /**
   * contentLinks
   */
  @ContentChildren(NavItemLinkDirective)
  contentLinks: QueryList<NavItemLinkDirective>;
  /**
   * links
   */
  @ViewChildren(NavItemLinkDirective) links: QueryList<NavItemLinkDirective>;
  /**
   * hasActiveLinks
   * @type {boolean}
   */
  @HostBinding('class.is-active') hasActiveLinks = false;

  /**
   * constructor
   */
  constructor() {}

  /**
   * grouped
   * @returns {boolean}
   */
  get grouped(): boolean {
    return this.children.some((item) => !item.link);
  }

  /**
   * ngAfterContentChecked
   */
  ngAfterContentChecked(): void {
    this.checkLinks();
  }

  /**
   * checkLinks
   */
  checkLinks(): void {
    if (!this.links) return;

    this.hasActiveLinks = [...this.links.toArray(), ...this.contentLinks.toArray()].some((link) => {
      return link.element.nativeElement.classList.contains('is-active');
    });
  }
}
